import { useQuery } from 'react-query';
import { CompaniesForSelectsResponse } from './companyTypes';
import { getCompaniesForSelects } from './companyService';

type Props<M> = {
    onError?: (error: Error) => void;
    onSuccess?: (data: CompaniesForSelectsResponse) => void;
    mapper?: (
        data?: CompaniesForSelectsResponse
    ) => M | CompaniesForSelectsResponse | undefined;
    enabled?: boolean;
};

const defaultMapper = (data?: CompaniesForSelectsResponse) => data;

export const useGetCompaniesForSelects = <M = CompaniesForSelectsResponse>({
    onError = () => {},
    onSuccess = () => {},
    mapper = defaultMapper,
    enabled = true,
}: Props<M>) => {
    const query = useQuery<CompaniesForSelectsResponse, Error>(
        ['companiesForSelects'],
        getCompaniesForSelects,
        {
            onSuccess,
            onError,
            enabled: enabled,
        }
    );

    return {
        data: mapper(query.data) as M,
        isLoading: query.isLoading,
        error: query.error,
        query,
    };
};
